import { withTheme } from '@front10/container-elements';
import withCommonEMContainer from '../_commons/CommonEMContainer';
import EventsGrid from './EventsGrid';

export default withCommonEMContainer(withTheme(EventsGrid));
